import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InitEndpoint } from './init-endpoint';
import { ContactRoutingResolver } from '../../pages/contact/contact-routing.resolver';
import { ProjectsRoutingResolver } from '../../pages/projects/projects-routing.resolver';
import { FrontpageRoutingResolver } from '../../pages/frontpage/frontpage-routing.resolver';
import { ProjectDetailRoutingResolver } from '../../pages/projects/project-detail/project-detail-routing.resolver';
import { ProjectsComponent } from '../../pages/projects/projects.component';
import { DefaultRoutingResolver } from '../../pages/default/default-routing.resolver';
import { BackstageRoutingResolver } from '../../pages/backstage/backstage-routing.resolver';

class HackyHttpHeaders extends HttpHeaders {
  has(name: string): boolean {
    // Pretend the `Accept` header is set, so `HttpClient` will not try to set the default value.
    return name?.toLowerCase() === 'accept' ? true : super.has(name);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  public initObject!: InitEndpoint.Response;

  private router = this.injector.get(Router);

  constructor(private injector: Injector, private http: HttpClient) { }

  /*
    controls the loading of the backend content api endpoint
    and returns a resolved promise if everthing is fine
  */

  initRoutes(): Promise<any> {
    return new Promise((resolve, reject) => {
      console.warn('initRoutes()');
      this.http
        .get<InitEndpoint.Response>('/api/init.json', {
          headers: new HackyHttpHeaders(),
        })
        .subscribe(
          (response: any) => {
            this.initObject = response;
            // console.debug(response);
            this.initObject.routes.forEach((route) => {
              this.addRoutes(route);
            });
            this.addFallbackRoute();
            // console.log(this.router.config);
            this.router.initialNavigation();
            resolve(null);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  private addFallbackRoute(): void {
    this.router.config.push({
      path: '**',
      redirectTo: '/',
      pathMatch: 'full',
    });
  }

  /*
    this function injects the routes into the angular route
    and delivers and state also an guard for registred and unregistered content
  */
  private addRoutes(entry: InitEndpoint.Route): void {
    if (typeof entry.uri !== 'undefined') {
      switch (entry.componentType) {
        case 'defaultPage':
          this.router.config.splice(1, 0, {
            path: entry.uri,
            loadChildren: () =>
              import('./../../pages/default/default.module').then(
                (m) => m.DefaultModule
              ),
            data: {
              dataUrl: entry.dataUrl,
            },
            resolve: {
              page: DefaultRoutingResolver,
            },
          });
          break;
        case 'homePage':
          this.router.config.splice(1, 0, {
            path: entry.uri,
            loadChildren: () =>
              import('./../../pages/frontpage/frontpage.module').then(
                (m) => m.FrontpageModule
              ),
            data: {
              dataUrl: entry.dataUrl,
            },
            resolve: {
              page: FrontpageRoutingResolver,
            },
          });
          break;
        case 'btsPage':
          this.router.config.splice(1, 0, {
            path: entry.uri,
            loadChildren: () =>
              import('./../../pages/backstage/backstage.module').then(
                (m) => m.BackstageModule
              ),
            data: {
              dataUrl: entry.dataUrl,
            },
            resolve: {
              page: BackstageRoutingResolver,
            },
          });
          break;
        case 'contactPage':
          this.router.config.splice(1, 0, {
            path: entry.uri,
            loadChildren: () =>
              import('./../../pages/contact/contact.module').then(
                (m) => m.ContactModule
              ),
            data: {
              dataUrl: entry.dataUrl,
            },
            resolve: {
              page: ContactRoutingResolver,
            },
          });
          break;
        case 'projectTypes':
          this.router.config.splice(1, 0, {
            path: entry.uri,
            loadChildren: () =>
              import('./../../pages/projects/projects.module').then(
                (m) => m.ProjectsModule
              ),
            data: {
              dataUrl: entry.dataUrl,
              category: entry.uri,
            },
            resolve: {
              page: ProjectsRoutingResolver,
            },
          });
          break;
        // ADDITIONALLY ADD PROJECT HERE FOR HIDDNE PROJECTS WITHOUT PROJECT TYPE. OTHERWISE THE children[] routin gin ProjectTypesModule would not be sufficient
        case 'project':
          this.router.config.splice(1, 0, {
            path: entry.uri,
            loadChildren: () =>
              import(
                './../../pages/projects/project-detail/project-detail.module'
              ).then((m) => m.ProjectDetailModule),
            data: {
              dataUrl: entry.dataUrl,
            },
            resolve: {
              page: ProjectDetailRoutingResolver,
            },
          });
          break;
      }
    }
  }
}
